module.exports = __webpack_public_path__ + "static/img/f_seacher.d238b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/f_seacher.jpg
// module id = pwE3
// module chunks = 171